// FILTER_NAME_CONSTANTS
export const TEXTUAL_SEARCH_IMAGE = "TEXTUAL_SEARCH_IMAGE";
export const TEXTUAL_SEARCH_OBJECT = "TEXTUAL_SEARCH_OBJECT";
export const VISUAL_SEARCH = "VISUAL_SEARCH";
export const SHOW_DS_VERSION = "SHOW_DS_VERSION";
export const ENABLE_DS_DUPLICATE = "ENABLE_DS_DUPLICATE";

export const REGION_SELECTION_SIMILARITY = "REGION_SELECTION_SIMILARITY";
export const DATA_INGESTION_TAB_AVAILABLE = "DATA_INGESTION_TAB_AVAILABLE";
export const USAGE_REPORT = "USAGE_REPORT";
export const DELETE_DATASET = "DELETE_DATASET";
export const EXPLORATION_DEBUG_INFO = "EXPLORATION_DEBUG_INFO";
export const DATASET_SHARE = "DATASET_SHARE";
export const CVAT_INTEGRATION = "CVAT_INTEGRATION";
export const ENRICHMENT_PREVIEWS = "ENRICHMENT_PREVIEWS";
export const CLUSTER_BY_DUPLICATES = "CLUSTER_BY_DUPLICATES";
export const UNIQUENESS_SCORE = "UNIQUENESS_SCORE";
export const PROMPT_SUPPORT_ENABLED = "PROMPT_SUPPORT_ENABLED";
export const MISLABEL_CONFIDENCE_FILTER_FOR_OBJECTS =
  "MISLABEL_CONFIDENCE_FILTER_FOR_OBJECTS";
export const MISLABEL_CONFIDENCE_FILTER_FOR_IMAGES =
  "MISLABEL_CONFIDENCE_FILTER_FOR_IMAGES";
export const ENRICHMENT_ENRICH_DATASET = "ENRICHMENT_ENRICH_DATASET";
export const TEXTUAL_SEARCH_RELEVANCE_SCORE_OBJECTS =
  "TEXTUAL_SEARCH_RELEVANCE_SCORE_OBJECTS";
export const TEXTUAL_SEARCH_RELEVANCE_SCORE_IMAGES =
  "TEXTUAL_SEARCH_RELEVANCE_SCORE_IMAGES";
export const OBJECT_SIZE_FILTER_ENABLED = "OBJECT_SIZE_FILTER_ENABLED";
export const FLYWHEEL = "FLYWHEEL";
export const VL_CHAT = "VL_CHAT";
export const DATASETS_JOB_SETUP_RECIPE_FILTERS =
  "DATASETS_JOB_SETUP_RECIPE_FILTERS";
export const TRAIN_WORTHY = "TRAIN_WORTHY";
export const TRAIN_MODEL = "TRAIN_MODEL";
export const VQL_UPGRADE = "VQL_UPGRADE";
export const VQL_EXCLUDE = "VQL_EXCLUDE";
export const DATASET_SNAPSHOTS = "DATASET_SNAPSHOTS";
export const USER_NOTIFICATIONS = "USER_NOTIFICATIONS";
export const ADD_MEDIA_TAB = "ADD_MEDIA_TAB";
export const USER_MANAGEMENT = "USER_MANAGEMENT";
export const DATASET_SNAPSHOTS_CREATE = "DATASET_SNAPSHOTS_CREATE";
export const DATASET_SNAPSHOTS_RESTORE = "DATASET_SNAPSHOTS_RESTORE";
export const CAPTIONS_FILTER = "CAPTIONS_FILTER";
export const VL_CHAT_DEBUG_CONSOLE_ENABLED = "VL_CHAT_DEBUG_CONSOLE_ENABLED";
export const MODELS_CATALOG = "MODELS_CATALOG";
export const RUNTIME_CONFIG = "RUNTIME_CONFIG";
export const DATASET_CREATION_V2 = "DATASET_CREATION_V2";
export const DATASET_INGESTION_ON_PREM = "DATASET_INGESTION_ON_PREM";
